import { createAction, props } from '@ngrx/store';

import { Subscription } from '../../subscriptions/subscriptions.interface';
import { Question, Answer } from '../../questions/questions.interface';
import { Analysis } from '../../analyses/analyses.interface';
import { InvitedInvestor, Pitch, HistoryRecord } from '../pitches.interface';

export const setPitch = createAction('[Pitch Component] Set Pitch', props<{ pitch: Pitch }>());

export const updatePitch = createAction('[Pitch Component] Update Pitch', props<{ pitch: { id: string; changes: Partial<Pitch> } }>());

export const setPitchInvitedInvestors = createAction(
  '[Pitch Component] Set Pitch Invited Investors',
  props<{ invitedInvestors: InvitedInvestor[] }>()
);

export const addInvestor = createAction('[Pitch Component] Add Investor', props<{ invitedInvestor: InvitedInvestor }>());

export const setPitchSubscriptions = createAction('[Pitch Component] Set Pitch Subscriptions', props<{ subscriptions: Subscription[] }>());

export const setPitchQuestions = createAction('[Pitch Component] Set Pitch Questions', props<{ questions: Question[] }>());

export const setPitchAnalyses = createAction('[Pitch Component] Set Pitch Analyses', props<{ analyses: Analysis[] }>());

export const setPitchChangesHistory = createAction(
  '[Pitch Component] Set Pitch Changes History',
  props<{ pitchChangesHistory: HistoryRecord[] }>()
);

export const updatePitchAnswer = createAction('[Pitch Component] Update Pitch Answer', props<{ id: string; answer: Answer }>());

export const updatePitchSubscriptionStatus = createAction(
  '[Pitch Component] Update Pitch Subscription Status',
  props<{ subscription: Subscription }>()
);

export const togglePitchQuestionStatus = createAction('[Pitch Component] Update Pitch Question Status', props<{ id: string }>());

export const togglePitchAnalysisStatus = createAction('[Pitch Component] Update Pitch Analysis Status', props<{ id: string }>());

export const togglePitchFeatureStatus = createAction('[Pitch Component] Update Pitch Feature Status', props<{ id: string }>());

export const deleteFile = createAction('[Pitch Component] Delete File', props<{ id: string }>());

export const updateExportStatus = createAction('[Pitch Component] Update Export Status', props<{ status: string }>());

export const changeAccountNumber = createAction('[Pitch Component] Change Account Number', props<{ accountNumber: string }>());

export const resetPitchState = createAction('[Pitch Component] Reset Pitch State');

// Requests

export const loadPitch = createAction('[Api/Request Pitch] Load Pitch', props<{ id: string }>());

export const loadPitchInvitedInvestors = createAction('[Api/Request Pitch] Load Pitch Invited Investors', props<{ id: string }>());

export const loadPitchSubscriptions = createAction('[Api/Request Pitch] Load Pitch Subscriptions', props<{ id: string }>());

export const loadPitchQuestions = createAction('[Api/Request Pitch] Load Pitch Questions', props<{ id: string }>());

export const loadPitchAnalyses = createAction('[Api/Request Pitch] Load Pitch Analyses', props<{ id: string }>());

export const loadPitchChangesHistory = createAction('[Api/Request Pitch] Load Pitch Changes History', props<{ id: string }>());

export const changePitchQuestionStatus = createAction('[Api/Request Pitch] Change Pitch Question Status', props<{ id: string }>());

export const changePitchAnswer = createAction(
  '[Api/Request Pitch] Change Pitch Answer',
  props<{ id: string; answer: string; userId: string }>()
);

export const changePitchSubscriptionStatus = createAction('[Api/Request Pitch] Change Pitch Subscription Status', props<{ id: string }>());

export const changePitchAnalysisStatus = createAction('[Api/Request Pitch] Change Pitch Analysis Status', props<{ id: string }>());
